<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>机组管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 视图区 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input placeholder="请输入内容" v-model="queryInfo.query" clearable @clear="getGroupList">
            <el-button slot="append" icon="el-icon-search" @click="getGroupList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="AddDialogVisible = true">添加</el-button>
        </el-col>
      </el-row>
      <!-- 用户列表 -->
      <el-table :data="GroupList" border stripe>
        <el-table-column label="#" type="index"></el-table-column>
        <el-table-column label="机架ID" prop="frame_id"></el-table-column>
        <el-table-column label="机架名称" prop="frame_name"></el-table-column>
        <el-table-column label="所在位置" prop="frame_local"></el-table-column>
        <el-table-column label="平均温度" prop="temp"></el-table-column>
        <el-table-column label="操作" width="380px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEidtDialog(scope.row.frame_id)">修改</el-button>
            <!-- 未分配机组 -->
            <el-button type="warning" icon="el-icon-setting" size="mini" @click="showDistributionDialog(scope.row.frame_id)">未分配</el-button>
            <!-- 已经分配机组 -->
            <el-button type="warning" icon="el-icon-setting" size="mini" @click="setipDialog(scope.row.frame_id)" style="background-color:#c471ed">已分配</el-button>
            <!-- 删除按钮 -->
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeCompanyById(scope.row.frame_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>
    <!-- 添加用户 -->
    <el-dialog title="添加机组" :visible.sync="AddDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体 -->
      <el-form ref="addFormRef" :model="addForm" label-width="70px">
        <el-form-item label="机组名称" prop="frame_name">
          <el-input v-model="addForm.frame_name"></el-input>
        </el-form-item>
        <el-form-item label="所在位置" prop="frame_local">
          <el-input v-model="addForm.frame_local" style="width: 35%;"></el-input>
        </el-form-item>

      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addframe">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改内容对话框 -->
    <el-dialog title="修改信息" :visible.sync="editDialogVisible" width="50%" @click="editDialogClosed">
      <el-form ref="editFormRef" :model="editForm" label-width="120px">
        <el-form-item label="机组ID" prop="frame_id" >
          <el-input v-model="editForm.frame_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="机组名称" prop="frame_name">
          <el-input v-model="editForm.frame_name"></el-input>
        </el-form-item>
        <el-form-item label="机组位置" prop="frame_local">
          <el-input v-model="editForm.frame_local"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editframe">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 分配机组 -->
    <el-dialog title="未分配主机" :visible.sync="DistributionDialogVisible" width="50%" >
        <el-table
         ref="multipleTable"
          :data="emptyIpsList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="ip"
            label="主机"
            style="width:100%">
          </el-table-column>
        </el-table>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="DistributionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addIP" >确认分配</el-button>
      </span>
    </el-dialog>
    <!-- 已分配机组 -->
    <el-dialog title="已分配主机(点击取消分配)" :visible.sync="setipDialogVisible" width="50%" >
        <el-table
         ref="multipleTable1"
          :data="existList"
          tooltip-effect="dark"
          style="width: 100%"
          @select="handleSelection"
          stripe
          border
          >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="ip"
            label="主机"
            style="width:100%"
            >
          </el-table-column>
        </el-table>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="setipDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Unassign">取消分配</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 获取用户参数
      queryInfo: {
        query: ''
      },
      // 控制添加信息对话框显示与隐藏
      AddDialogVisible: false,
      // 控制添加信息对话框显示与隐藏
      editDialogVisible: false,
      // 控制未分配分配权限对话框显示与隐藏
      DistributionDialogVisible: false,
      // 控制已经分配分配权限对话框显示与隐藏
      setipDialogVisible: false,
      editForm: {
        frame_id: '',
        frame_name: '',
        frame_local: ''
      },
      //  添加用户表单数据
      addForm: {
        frame_name: '',
        frame_local: ''
        // temp: ''
      },
      roleId: '',
      frameId: '',
      existList: [],
      emptyIpsList: [],
      GroupList: [],
      rightlist: [],
      selectList: [],
      UnassignList: []
    }
  },
  methods: {
    async getGroupList () {
      const { data: res } = await this.$http.get('frame/list')
      this.GroupList = res.data
      console.log(res)
    },
    // ~对话框关闭事件
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },
    // ~点击按钮添加新机组
    async addframe () {
      const { data: res } = await this.$http.post('frame/add', this.addForm)
      if (res.code === 200) {
        this.$message.success('添加成功！')
      } else this.$message.error('添加失败！')
      this.getGroupList()
      this.AddDialogVisible = false
    },
    // ~未分配机组信息
    async showDistributionDialog (id) {
      const { data: res } = await this.$http.get('frame/emptyIps')
      this.emptyIpsList = res.data
      // console.log(id)
      this.frameId = id
      this.DistributionDialogVisible = true
      console.log(res.data)
    },
    async setipDialog (id) {
      const { data: res } = await this.$http.post(`frame/exitIps/${id}`)
      this.existList = res.data
      this.$nextTick(() => {
        this.existList.forEach(row => {
          this.$refs.multipleTable1.toggleRowSelection(row, true)
        })
      })
      this.setipDialogVisible = true
      console.log(res.data)
    },
    showEidtDialog (id) {
      this.editDialogVisible = true
      this.editForm.frame_id = id
    },
    // ~修改机组信息框
    async editframe () {
      const { data: res } = await this.$http.post('frame/update', {
        frame_id: this.editForm.frame_id,
        frame_name: this.editForm.frame_name,
        frame_local: this.editForm.frame_local
      })
      if (res.code === 200) this.$message.success('修改成功')
      else this.$message.error('修改失败')
      this.getGroupList()
      this.editDialogVisible = false
    },
    // ~修改信息对话框关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },

    // ~ 删除机组方法
    async removeCompanyById (id) {
      const removeconfirm = await this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (removeconfirm !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post(`frame/del/${id}`)
      if (res.code === 200) {
        this.$message.success('删除成功！')
      } else this.$message.error('删除失败！')
      this.getGroupList()
    },
    // 确认分配
    async  addIP () {
      const { data: res } = await this.$http.post('frame/addIp', { userIpList: this.selectList, frameId: this.frameId })
      if (res.code === 200) {
        this.$message.success('分配成功！')
      } else this.$message.error('分配失败！')
      this.DistributionDialogVisible = false
    },
    // 取消分配
    async Unassign () {
      const { data: res } = await this.$http.post('frame/remove', { userIpList: this.UnassignList })
      if (res.code === 200) {
        this.$message.success('取消成功！')
      } else this.$message.error('取消失败！')
    },
    // 未分配选中信息
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectList = []
      for (const i in val) {
        this.selectList.push(val[i].ip)
      }
      // console.log('@@@@@', this.selectList)
    },

    handleSelection (list, item) {
      if (!list.includes(item)) {
        // 取消勾选时做的事，arguments[1]是当前取消勾选的项
        const args = Array.from(arguments)
        this.UnassignList.push(args[1].ip)
        console.log(this.UnassignList)
      }
    }
  },
  created () {
    this.getGroupList()
  }
}
</script>

<style lang="less" scoped></style>
